import React, { useEffect, useState } from 'react'
import { Flex, P, Switch } from 'ui/bend'

export const CompletedClassFilter = ({
  applyFilter,
  removeFilter,
  excludeCompleted
}) => {
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (excludeCompleted) {
      setChecked(true)
    } else {
      setChecked(false)
    }
  }, [excludeCompleted])
  return (
    <Flex
      style={{ gap: '10px', alignItems: 'center' }}
      paddingTop={['1rem', '1rem', '0', '0']}
      px={['1rem', '1rem', '0', '0']}
      paddingBottom={['1rem', '1rem', '1rem', '1rem']}
      className='ExcludeCompletedSwitch'
    >
      <Switch
        label='Toggle Completed'
        name='toggleCompleted'
        id='toggleCompleted'
        checked={checked}
        onChange={() => {
          if (!checked) {
            applyFilter('excludeCompleted', !checked)
          } else {
            removeFilter('excludeCompleted', checked)
          }
          setChecked(!checked)
        }}
      />
      <P style={{ textAlign: 'left' }} margin={'0'}>
        Hide Completed
      </P>
    </Flex>
  )
}
